// Add your custom JS here.

/*
 * Get updated cabinet price from the server
 * Version: 1.0.0
 * Description: This script is used to get the updated cabinet price from the server
 */
import Tooltip from 'bootstrap/js/dist/tooltip';

// Listen for input value changes
var expandAll = document.getElementById('expandAll');
var collapseAll = document.getElementById('collapseAll');

if (expandAll) {
  expandAll.addEventListener('click', function () {
    const accordions = document.querySelectorAll('.accordion-collapse');
    accordions.forEach(function (accordion) {
      if (!accordion.classList.contains('show')) {
        accordion.classList.add('show');
      }
    });
  });
}

if (collapseAll) {
  collapseAll.addEventListener('click', function () {
    const accordions = document.querySelectorAll('.accordion-collapse');
    accordions.forEach(function (accordion) {
      if (accordion.classList.contains('show')) {
        accordion.classList.remove('show');
      }
    });
  });
}

jQuery("input[type='number']").on("input keyup paste", function () {
  var value = parseInt(jQuery(this).val(), 10); // Convert string value to integer
  var min = parseInt(jQuery(this).attr("min"), 10); // Convert min attribute value to integer
  var max = parseInt(jQuery(this).attr("max"), 10); // Convert max attribute value to integer

  if (value < min || value > max) {
    // Show notification if value is out of range
    jQuery("#notification").removeClass("d-none");

    // Add 'is-invalid' class to highlight the incorrect field
    jQuery(this).addClass("is-invalid");
  } else {
    // Hide notification if value is within range
    jQuery("#notification").addClass("d-none");

    // Remove 'is-invalid' class when the input is correct
    jQuery(this).removeClass("is-invalid");
  }
});


// Initialize tooltips
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));

//hide drawer front height field if equal drawers is checked
jQuery(document).ready(function () {
  jQuery("#Web_Equal_Drawers").change(function () {
    if (jQuery(this).is(":checked")) {
      jQuery("#col_Top_Drawer_Front_Height").hide();
    } else {
      jQuery("#col_Top_Drawer_Front_Height").show();
    }
  });
});

jQuery(document).ready(function () {
  //check if client is desktop
  function isDesktop() {
    return window.matchMedia("(min-width: 992px)").matches;
  }
});

const myOffcanvas = document.getElementById("navbarNavOffcanvas");
myOffcanvas.addEventListener("hidden.bs.offcanvas", (event) => {
  jQuery("#mobile-nav-footer").addClass("d-none");

});

myOffcanvas.addEventListener("show.bs.offcanvas", (event) => {
  jQuery("#mobile-nav-footer").removeClass("d-none");

});

//check if client is desktop
function isDesktop() {
  return window.matchMedia("(min-width: 992px)").matches;
}

jQuery(document).ready(function () {
  //if client is desktop, activate dropdowns on hover
  if (isDesktop()) {
    jQuery(".dropdown").hover(
      function () {
        jQuery(this).addClass("show");
        jQuery(this).find(".dropdown-menu").addClass("show");
      },
      function () {
        jQuery(this).removeClass("show");
        jQuery(this).find(".dropdown-menu").removeClass("show");
      }
    );
  }
});

//update cart JS
function updateCartIcon() {
  // Make an AJAX request to get the cart count
  jQuery.ajax({
    url: "/wp-admin/admin-ajax.php",
    type: "POST",
    data: {
      action: "get_cart_count",
    },
    success: function (response) {
      const count = parseInt(response);
      const cartIcon = document.querySelector(".bi-cart4.position-relative");

      // Check if a badge already exists
      let badge = cartIcon.querySelector(".cart-badge");

      if (!badge && count > 0) {
        // Create a badge if it doesn't exist
        badge = document.createElement("span");
        badge.className =
          "position-absolute top-0 start-100 badge rounded-pill bg-danger  cart-badge fs-5";

        const visuallyHiddenSpan = document.createElement("span");
        visuallyHiddenSpan.className = "";
        visuallyHiddenSpan.textContent = "Cart Items";
        badge.appendChild(visuallyHiddenSpan);

        cartIcon.appendChild(badge);
      }

      if (count > 0) {
        badge.firstChild.textContent = count;
      } else {
        // Remove badge if count is zero
        badge && badge.remove();
      }
    },
  });
}

// Call the function on page load
document.addEventListener("DOMContentLoaded", function () {
  updateCartIcon();
});



jQuery(document).ready(function () {
  jQuery("#field_door_type")
    .change(function () {
      // First, hide all elements
      jQuery(
        "#field_thermofoil_colour, #field_door_style_thermofoil, #field_five_piece_colour, #field_door_style_five_piece, #field_slab_colour"
      ).closest('.project-option-field').hide();

      switch (jQuery(this).val()) {
        case "Thermofoil":
          jQuery(
            "#field_thermofoil_colour, #field_door_style_thermofoil"
          ).closest('.project-option-field').show();
          break;

        case "Five Piece":
          jQuery(
            "#field_five_piece_colour, #field_door_style_five_piece"
          ).closest('.project-option-field').show();
          break;

        case "Slab":
          jQuery("#field_slab_colour").closest('.project-option-field').show();
          break;

        case "No Doors":
          jQuery("#field_slab_colour").closest('.project-option-field').show();
          break;
      }
    })
    .trigger("change"); // Trigger once to set initial visibility

  jQuery("#field_drawer_slide")
    .change(function () {
      // First, hide all elements
      jQuery("#field_drawer_box_colour").closest('.project-option-field').hide();

      switch (jQuery(this).val()) {
        case "Movento":
          jQuery("#field_drawer_box_colour").closest('.project-option-field').show();
          break;
      }
    })
    .trigger("change"); // Trigger once to set initial visibility
});

export function initializePriceCalculation() {

  const cart_form = jQuery("form.cart");
  let form_fields = cart_form.find("input, select");

  jQuery(".woocommerce-Price-amount.amount").html(
    '<div class="spinner-border text-success" role="status"><span class="visually-hidden">Loading...</span></div>'
  );
  let data = {};
  let product_id = jQuery(".product").attr("id").split("-")[1]; // product id

  data.product_id = product_id;

  for (let i = 0; i < form_fields.length; i++) {
    if (form_fields[i].type === "checkbox") {
      data[form_fields[i].name] = form_fields[i].checked;
    } else if (form_fields[i].type === "number") {
      data[form_fields[i].name] = form_fields[i].value;
    } else if (form_fields[i].type === "hidden") {
      data[form_fields[i].name] =
        form_fields[i].value === "yes"
          ? true
          : form_fields[i].value === "no"
            ? false
            : form_fields[i].value;
    } else if (form_fields[i].tagName === "SELECT") {
      let selected_option =
        form_fields[i].options[form_fields[i].selectedIndex].value;
      data[form_fields[i].name] = selected_option;
    }
  }

  // Add calculate_client_price action
  data.action = "calculate_client_price";
  data.nonce = client_price.nonce;

  jQuery.ajax({
    type: "POST",
    url: "/wp-admin/admin-ajax.php",
    data: data,
    success: function (response) {
      const textclass = "text-body-tertiary";
      jQuery(".woocommerce-Price-amount.amount").html(response.price);
      jQuery(".woocommerce-Price-amount.amount").removeClass(textclass);
    },
    error: function (xhr, status, error, data, response) {
      // Handle error
    },
  });
}

// Automatically initialize the listener when the module is loaded
(function () {
  jQuery(document).ready(function () {

    const cart_form = jQuery("form.cart");
    let form_fields = cart_form.find("input, select"); 

    // Listen for changes in input fields
    form_fields.on("change", debounce(initializePriceCalculation, 250));

  }
  );


  function debounce(func, wait) {
    console.log("debounce");
    let timeout;
    return function (...args) {
      const context = this; // Preserve `this` context
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }


}
)();




jQuery(document).ready(function () {
  // Target the parent menu item by class name and add a click event
  jQuery(".menu-item-store").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/product-category/cabinets/";
  });
});

